import React from 'react';
import { motion } from 'framer-motion';
import {
  Printer,
  Shield,
  Zap,
  HeadphonesIcon,
} from 'lucide-react';

const services = [
  {
    icon: <Printer className="h-8 w-8" />,
    title: 'Instalación y Capacitación',
    description:
      'Instalación profesional de equipos Canon y HP con capacitación personalizada para uso eficiente.',
    color: 'blue',
    bgColor: 'bg-blue-50',
    textColor: 'text-blue-600'
  },
  {
    icon: <Shield className="h-8 w-8" />,
    title: 'Servicio Técnico Récord',
    description:
      'Mantenimiento preventivo y correctivo con profesionales altamente calificados. Respuesta en tiempo récord.',
    color: 'green',
    bgColor: 'bg-green-50',
    textColor: 'text-green-600'
  },
  {
    icon: <Zap className="h-8 w-8" />,
    title: 'Refacciones y Consumibles',
    description:
      'Tóner incluido, disponibilidad de consumibles y refacciones para todos los modelos (excepto papel).',
    color: 'orange',
    bgColor: 'bg-orange-50',
    textColor: 'text-orange-600'
  },
  {
    icon: <HeadphonesIcon className="h-8 w-8" />,
    title: 'Cambio de Equipo',
    description:
      'Reemplazo inmediato del equipo en caso de falla mayor. Sin interrupciones en tu operación.',
    color: 'purple',
    bgColor: 'bg-purple-50',
    textColor: 'text-purple-600'
  },
];

export const Services = () => {
  return (
    <section id="servicios" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-primary font-semibold text-sm uppercase tracking-wide">
            Nuestros Servicios
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mt-3">
            Renta de Impresoras Multifuncionales
          </h2>
          <p className="text-lg text-gray-600 mt-4 max-w-2xl mx-auto">
            Servicios completos para renta de impresoras Canon y HP en Los Cabos
          </p>
        </motion.div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ y: -8 }}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100"
            >
              <div className={`${service.bgColor} w-16 h-16 rounded-xl flex items-center justify-center ${service.textColor} mb-6`}>
                {service.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">{service.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
